<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2025-03-12 16:02:56
 * @LastEditors: sjq
 * @LastEditTime: 2026-06-16 17:21:13
 -->
<template>
  <div class="gift-card-page" v-if="isAddAdviser !== null">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" :isDefaultBack="false" :transparent="true" bgcolor="#00b25a" back-type="back-app" />
    <template v-if="isAddAdviser">
      <div class="background" v-if="cardInfo.cardNo">
        <img src="../../images/goods/gift_head.png" alt="" />
      </div>
      <div class="con" :style="{ marginTop: hasHeader ? '0' : '44px' }" v-if="cardInfo.cardNo">
        <div class="card">
          <img :src="cardInfo.giftCardImg" alt="" />
        </div>
        <div class="intro">
          <p class="tit">{{ cardInfo.name }}</p>
          <p>{{ cardInfo.descr }}</p>
        </div>
        <div
          v-if="
            cardInfo.userStatusList &&
            cardInfo.userStatusList.length &&
            cardInfo.userStatusList.find(item => item.code === 'giftCard.customer.newUser')
          "
          class="gif-card-commit"
        >
          注：本礼品卡限新注册用户使用
          <!-- <van-icon name="question-o" /> -->
        </div>
        <div class="gift-message-card gift-message-h" v-if="cardInfo.useLimitType !== 'useSelf'">
          <div class="gift-message-header">
            <span class="gift-message-title">赠言</span>
            <div v-if="!+sourceUserId" class="gift-message-actions">
              <span v-if="!isEditingMessage" class="gift-message-edit" @click="startEditMessage">
                <van-icon name="edit" />
                编辑
              </span>
              <span v-else class="gift-message-count">{{ editingMessage.length }}/100</span>
            </div>
          </div>
          <div v-if="isEditingMessage" class="gift-message-editor">
            <textarea
              ref="giftMessageTextarea"
              v-model="editingMessage"
              class="gift-message-textarea"
              @input="autoResizeTextarea"
              placeholder="给您的好友写些什么吧"
              maxlength="100"
            ></textarea>
          </div>
          <div v-else ref="giftMessageContent" class="gift-message-content">
            {{ displayGiftMessage || '给您的好友写些什么吧' }}
          </div>
          <div class="gift-message-footer">
            <span class="gift-message-name">{{ giftMessageName }}</span>
            <span class="gift-message-date">{{ giftMessageDate }}</span>
          </div>
        </div>
        <div class="gift-detail" v-if="+sourceUserId && cardInfo.guideContent">
          <div class="detail-title">礼品卡介绍</div>
          <goods-content :content="cardInfo.guideContent" class="content" />
        </div>
      </div>
      <div class="fixed-bottom" v-if="cardInfo.cardNo">
        <div
          class="tips"
          v-if="
            (!+sourceUserId && isUnuse) ||
            (+sourceUserId && isUnuse) ||
            hasDraw ||
            (!+sourceUserId && cardInfo.status === 3)
          "
        >
          <p class="tip" v-if="!+sourceUserId && isUnuse">
            请在 {{ cardInfo.effectiveEndTime }}前{{ getUseLimitTypeText(cardInfo) }}，逾期失效
          </p>

          <p class="tip" v-if="+sourceUserId && isUnuse">请在 {{ cardInfo.effectiveEndTime }}前领取使用，逾期失效</p>
          <p class="tip" v-if="hasDraw || (!+sourceUserId && cardInfo.status === 3)">
            领取好友：{{ cardInfo.useUserName }}
          </p>
          <div
            class="tip"
            v-if="cardInfo.useLimitType !== 'useSelf' && isAndroid"
            @click="copyGiftLink"
            style="color: #000; margin-top: 16px"
          >
            分享遇到问题？
            <span style="color: #347998">点击复制分享链接</span>
          </div>
        </div>
        <div class="flexdiv average">
          <div class="btns" v-if="!+sourceUserId && isUnuse">
            <button class="bg btn" v-if="cardInfo.useLimitType !== 'useSelf' && appUser.isNative" @click="sendFn">
              微信链接赠送
            </button>
            <button class="bg btn" v-if="cardInfo.useLimitType !== 'useSelf'" @click="generatePoster">
              生成海报赠送
            </button>
            <button class="btn useSelf" v-if="cardInfo.useLimitType !== 'give'" @click="useSelf">自己使用</button>
          </div>
          <button class="btn unbg" v-if="isUse">已使用</button>
          <button class="btn unbg" v-if="isUnuse && +sourceUserId === +userId">仅限好友领取</button>
          <button class="btn unbg" v-if="isReceived">已领取</button>
          <button class="btn unbg" v-if="hasReceived">已被领取</button>
          <button class="btn unbg" v-if="cardInfo.status === 2">已失效</button>
          <button
            class="btn bg"
            v-if="(+sourceUserId && isUnuse && +sourceUserId !== +userId) || isTest"
            @click="useGiftCard"
          >
            立即领取
          </button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="container-bg">
        <img class="title" src="../../images/add_teacher_title.png" alt="" />
        <div class="border-popup-white">
          <div class="ccontent">
            <div class="text text1">第一步</div>
            <div class="text text2">获取领取资格</div>
            <div class="text text3">第二步</div>
            <div class="text" style="line-height: 1.5">添加班主任，回复「开通」，为你确认课程权益</div>
            <div class="adviserCode">
              <img class="img" :src="adviserDetail.adviserCode" />
              <div class="long-tap-box">长按图片，扫一扫添加</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 海报弹窗 -->
    <div class="poster-overlay" v-if="showPoster" @click="showPoster = false">
      <div class="poster-wrapper" @click.stop>
        <img class="poster-img" :src="posterImage" alt="海报" />
        <p class="poster-tip">长按图片保存到相册</p>
      </div>
    </div>

    <div class="gift-card-page" id="gift-card-poster">
      <div class="background" v-if="cardInfo.cardNo">
        <img src="../../images/goods/gift_head.png" alt="" />
      </div>
      <div class="card-detail">
        <div class="card-name">
          {{ cardInfo.name }}
        </div>
        <div class="card-img">
          <img :src="cardInfo.giftCardImg" alt="" />
        </div>
        <div class="gift-message-card">
          <div class="gift-message">{{ displayGiftMessage }}</div>
          <div class="gift-message-footer">
            <span class="gift-message-name">{{ giftMessageName }}</span>
            <span class="gift-message-date">{{ giftMessageDate }}</span>
          </div>
        </div>
        <div class="poster-share">
          <img
            class="poster-logo"
            src="https://img-cdn1.ylyk.com/image/1777540346946_m1777540340818_s6363.jpg"
            alt=""
          />
          <div class="poster-text">
            <div class="poster-title">长按识别二维码</div>
            <div class="poster-subtitle">领取专属礼品卡</div>
          </div>
          <img class="poster-qrcode" :src="qrImgUrl" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { hasHeader } from '@/components/app/index'
import Body from '@/mixins/body'
import { MessageBox, Toast } from 'mint-ui'
import { appUser } from '@/utils/auth'
import { toLoginView } from '@/utils/init/env-init'
import { $settingBounces, $toShare, $getShareImg } from '@/utils/common/native-api'
import { saTrack } from '@/utils/common/shence'
import { Dialog, Icon } from 'vant'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
import { getPageUrl } from '@/utils/common/url'
import { getCookie } from '@/utils/common/cookie'
import GoodsContent from './components/goods-content'
import service from '@/api/modules/gift-card'
import { copyTextToClipboard } from '@/utils/clipboard'

// 操作名称
const action = 'drawGiftcard'

export default {
  name: 'GiftCard',
  components: { 'van-icon': Icon, GoodsContent },
  data() {
    return {
      appUser,
      // isSuccess: false,
      title: '我的礼品卡',
      userId: appUser.userId,
      hasHeader: hasHeader(),
      isAddAdviser: null,
      isEditingMessage: false,
      editingMessage: '',
      innerContentNo: '',
      showPoster: false,
      posterImage: '',
      qrImgUrl: '',
      sharePageUrl: '',
      adviserDetail: {},
      // 倒计时
      countdownTime: 0,
      countdownTimer: null,
      useGiftCardPollTimer: null,
      hasRedirected: false,
      hasTrackedVisit: false
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('gift-card/card', ['cardInfo', 'drawInfo']),
    ...mapGetters('args', ['sourceUserId', 'cardId', 'contentNo', 'test', 'fromChannel']),
    isAndroid() {
      return getCookie('appVersionAndroid')
    },
    isUnuse() {
      return this.cardInfo.status === 0
    },
    isTest() {
      return this.test != null
    },
    isUse() {
      return this.cardInfo.status === 1
    },
    isReceived() {
      return this.cardInfo.status === 3 && +this.sourceUserId && +this.userId === +this.cardInfo.useUserId
    },
    hasReceived() {
      return (
        (this.cardInfo.status === 3 || this.cardInfo.status === 1) &&
        +this.sourceUserId &&
        +this.userId !== +this.cardInfo.useUserId
      )
    },
    hasDraw() {
      return (
        +this.sourceUserId &&
        (this.cardInfo.status === 3 || this.cardInfo.status === 1) &&
        +this.cardInfo.useUserId !== +this.userId &&
        +this.sourceUserId !== +this.userId
      )
    },
    // 倒计时格式化
    countdownText() {
      const minutes = Math.floor(this.countdownTime / 60)
      const seconds = this.countdownTime % 60
      return {
        h: String(minutes).padStart(2, '0'),
        m: String(seconds).padStart(2, '0')
      }
    },
    giftMessageName() {
      return this.cardInfo.sourceUserName || this.cardInfo.createUserName || ''
    },
    giftMessageDate() {
      const date = this.cardInfo.cardShareTime || Date.now()
      return this.formatGiftMessageDate(date)
    },
    displayGiftMessage() {
      return this.editingMessage || this.cardInfo.cardMessage || '给您的好友写些什么吧'
    }
  },
  watch: {
    isAddAdviser(val) {
      if (val === false) {
        this.startCountdown()
        this.startUseGiftCardPolling()
      } else {
        this.stopUseGiftCardPolling()
      }
    },
    'cardInfo.cardMessage': {
      handler(val) {
        if (!this.isEditingMessage) {
          this.editingMessage = val || ''
        }
      },
      immediate: true
    }
  },
  created() {
    $settingBounces({
      bounces: 'disenable'
    })
    if (+this.sourceUserId) {
      this.title = '领取礼品卡'
    }
    this.getGiftCardById()
    var { style, clientWidth, clientHeight } = document.documentElement
    style.fontSize = Math.min(clientWidth, clientHeight) / 7.5 + 'px'
  },

  methods: {
    startUseGiftCardPolling() {
      this.stopUseGiftCardPolling()
      this.getUseGiftCardData()
      this.useGiftCardPollTimer = setInterval(() => {
        this.getUseGiftCardData()
      }, 5000)
    },
    stopUseGiftCardPolling() {
      if (this.useGiftCardPollTimer) {
        clearInterval(this.useGiftCardPollTimer)
        this.useGiftCardPollTimer = null
      }
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      const { cardInfo } = this
      this.enterAfterLogin(cardInfo)
    },
    // 文案适配
    getUseLimitTypeText(cardInfo) {
      const { useLimitType: type } = cardInfo
      if (type === 'useSelf') return '自己使用'
      if (type === 'give') return '赠送好友'
      return '赠送好友或自己使用'
    },
    formatGiftMessageDate(date) {
      if (!date) return ''
      const value = new Date(date)
      if (Number.isNaN(value.getTime())) {
        return String(date).slice(0, 10)
      }
      const year = value.getFullYear()
      const month = String(value.getMonth() + 1).padStart(2, '0')
      const day = String(value.getDate()).padStart(2, '0')
      return `${year}.${month}.${day}`
    },
    autoResizeTextarea() {
      const textarea = this.$refs.giftMessageTextarea
      if (!textarea) return
      textarea.style.height = 'auto'
      textarea.style.height = textarea.scrollHeight + 'px'
    },
    startEditMessage() {
      const contentEl = this.$refs.giftMessageContent
      const contentHeight = contentEl ? contentEl.scrollHeight : 0
      this.editingMessage = this.displayGiftMessage
      this.isEditingMessage = true
      this.$nextTick(() => {
        const textarea = this.$refs.giftMessageTextarea
        if (!textarea) return
        if (contentHeight) {
          textarea.style.height = contentHeight + 'px'
        } else {
          this.autoResizeTextarea()
        }
        textarea.focus()
        const cursorPosition = this.editingMessage.length
        if (typeof textarea.setSelectionRange === 'function') {
          textarea.setSelectionRange(cursorPosition, cursorPosition)
        }
      })
    },

    sendFn() {
      const cardMessage = (this.isEditingMessage ? this.editingMessage : this.displayGiftMessage).trim()
      if (!cardMessage) {
        Toast({ message: '赠言不可为空哦~', position: 'bottom' })
        return
      }
      this.$store
        .dispatch('gift-card/card/saveCardMessage', {
          cardMessage,
          cardNo: this.cardId,
          messageType: '链接'
        })
        .then(res => {
          let contentNo = res.contentNo || res.messageNo
          this.sharePageUrl = getPageUrl({
            page: 'payment.html',
            route: '/gift-card',
            params: {
              sourceUserId: getCookie('appUserId') || appUser.userId,
              cardId: this.cardId,
              contentNo: contentNo,
              fromChannel: 'url'
            }
          })
          this.isEditingMessage = false
          this.editingMessage = cardMessage
          this.getGiftCardById()
          $toShare({
            message: '调起wx',
            sharePageUrl: this.sharePageUrl,
            shareMainTitle: this.cardInfo.shareMainTitle,
            shareSecondTitle: this.cardInfo.shareSecondTitle,
            shareImg: this.cardInfo.shareImg,
            sharePlatform: 'wechatSession',
            trackName: 'gift_card_share',
            trackData: this.getGiftCardShareTrackData('微信链接赠送', contentNo),
            trackCallbackName: 'share_callback'
          })
        })
    },
    generatePoster() {
      const cardMessage = (this.isEditingMessage ? this.editingMessage : this.displayGiftMessage).trim()
      if (!cardMessage) {
        Toast({ message: '赠言不可为空哦~', position: 'bottom' })
        return
      }
      this.$store
        .dispatch('gift-card/card/saveCardMessage', {
          cardMessage,
          cardNo: this.cardId,
          messageType: '二维码'
        })
        .then(res => {
          let contentNo = res.contentNo || res.messageNo
          this.sharePageUrl = getPageUrl({
            page: 'payment.html',
            route: '/gift-card',
            params: {
              sourceUserId: getCookie('appUserId') || appUser.userId,
              cardId: this.cardId,
              contentNo: contentNo,
              fromChannel: 'qr'
            }
          })
          this.$nextTick(() => {
            QRCode.toDataURL(this.sharePageUrl, {
              errorCorrectionLevel: 'L',
              type: 'image/jpeg',
              quality: 0.3,
              margin: 1
            }).then(qrUrl => {
              this.qrImgUrl = qrUrl
              this.$nextTick(() => {
                const target = this.$el.querySelector('#gift-card-poster')
                if (!target) return
                Toast({ message: '海报生成中...', position: 'bottom' })
                html2canvas(target, {
                  useCORS: true,
                  allowTaint: true,
                  backgroundColor: '#fff',
                  scale: 2
                })
                  .then(canvas => {
                    this.posterImage = canvas.toDataURL('image/png')
                    if (appUser.isNative) {
                      $getShareImg({
                        imgUrl: this.posterImage,
                        trackName: 'gift_card_share',
                        trackData: this.getGiftCardShareTrackData('生成海报赠送', contentNo),
                        trackCallbackName: 'share_callback'
                      })
                    } else {
                      this.showPoster = true
                    }
                  })
                  .catch(() => {
                    Toast('海报生成失败')
                  })
              })
            })
          })
        })
    },
    // 复制礼品卡链接
    copyGiftLink() {
      const cardMessage = (this.isEditingMessage ? this.editingMessage : this.displayGiftMessage).trim()
      const loadingToast = Toast({ message: '生成链接中...', duration: 0 })
      this.$store
        .dispatch('gift-card/card/saveCardMessage', {
          cardMessage,
          cardNo: this.cardId,
          messageType: '复制链接'
        })
        .then(res => {
          loadingToast.close()
          const contentNo = res.contentNo || res.messageNo
          this.sharePageUrl =
            '点击领取【' +
            this.cardInfo.name +
            '】：' +
            getPageUrl({
              page: 'payment.html',
              route: '/gift-card',
              params: {
                sourceUserId: getCookie('appUserId') || appUser.userId,
                cardId: this.cardId,
                contentNo: contentNo,
                fromChannel: 'url'
              }
            })
          // 使用原生 copyTextToClipboard，不依赖 click event，异步回调中也能正常工作
          copyTextToClipboard(this.sharePageUrl)
          saTrack('gift_card_share', this.getGiftCardShareTrackData('复制链接', contentNo))
        })
        .catch(() => {
          loadingToast.close()
        })
    },
    getGiftCardById() {
      this.$store
        .dispatch('gift-card/card/getGiftCardById', {
          cardNo: this.cardId,
          contentNo: this.contentNo
        })
        .then(() => {
          this.enterAfterLogin()
          this.isAddAdviser = this.cardInfo.userUseStatus !== 4
          if (this.cardInfo.userUseStatus === 4) {
            this.getUseGiftCardData()
          }
          this.trackGiftCardVisit()
        })
    },
    getGiftCardShareTrackData(buttonName, contentNo) {
      return {
        share_id: `${appUser.userId || ''}_${Date.now()}`,
        card_id: this.cardInfo.giftCardId || this.cardId,
        card_no: this.cardInfo.cardNo || this.cardId,
        content_no: contentNo,
        button_name: buttonName
      }
    },
    trackGiftCardVisit() {
      if (this.hasTrackedVisit) return
      this.hasTrackedVisit = true
      saTrack('gift_card_visit', {
        card_id: this.cardInfo.giftCardId || this.cardId,
        card_no: this.cardInfo.cardNo || this.cardId,
        content_no: this.contentNo,
        inviter_id: this.sourceUserId,
        user_id: appUser.userId,
        fromChannel: this.fromChannel === 'qr' ? '二维码' : '链接'
      })
    },
    trackUseGiftCard(result) {
      saTrack('use_giftcard', {
        result,
        card_id: this.cardInfo.giftCardId || this.cardId,
        card_no: this.cardInfo.cardNo || this.cardId,
        content_no: this.contentNo,
        inviter_id: this.sourceUserId,
        user_id: appUser.userId,
        fromChannel: this.fromChannel === 'qr' ? '二维码' : '链接'
      })
    },
    enterAfterLogin(cardInfo) {
      return this.$store.dispatch('user/login/enterAfterLogin', { action }).then(action => {
        this.$nextTick(this.useGiftCard)
        return action
      })
    },
    useGiftCard(type) {
      if (type !== 'useSelf' && this.cardInfo.useWxOnly === 1 && !this.appUser.isWeixin) {
        Toast('本礼品卡必须在微信中领取~')
        return
      }
      // 无token去登录
      if (!this.hasToken({ action })) {
        this.$step({ message: '获取登录信息~', action })
        toLoginView({ type: 'button', action })
      } else {
        const sourceId = this.sourceUserId ? this.sourceUserId : this.userId
        this.$store
          .dispatch('gift-card/card/useGiftCard', {
            sourceUserId: sourceId,
            useUserId: this.userId || appUser.userId,
            cardNo: this.cardId,
            cardMessage: this.cardInfo.cardMessage
          })
          .then(() => {
            this.trackUseGiftCard('成功')
            this.getGiftCardById()
            if (!this.sourceUserId) {
              Toast('使用成功')
            } else {
              if (this.cardInfo.obtainType === 1) {
                this.isAddAdviser = true
                this.getUseGiftCardData()
              } else {
                const name = 'giftcard-success'
                const params = { drawInfo: this.drawInfo, giftCardId: this.cardInfo.giftCardId }
                this.$router.replace({ name, params })
              }
            }
          })
          .catch(err => {
            this.trackUseGiftCard((err && (err.message || err.msg)) || '失败')
          })
      }
    },
    useSelf() {
      MessageBox.confirm(`确定自己使用${this.cardInfo.name}礼品卡吗？`, {
        title: '',
        confirmButtonClass: 'confirm-btn-class'
      }).then(action => {
        if (action === 'confirm') {
          this.useGiftCard('useSelf')
        }
      })
    },
    getUseGiftCardData() {
      const sourceId = this.sourceUserId ? this.sourceUserId : this.userId
      return service
        .getUseGiftCardData({
          sourceUserId: sourceId,
          useUserId: this.userId || appUser.userId,
          cardNo: this.cardId,
          cardMessage: this.cardInfo.cardMessage
        })
        .then(res => {
          this.userId = this.userId || res.userId
          this.adviserDetail = res
          if (!res.startTime) {
            this.stopUseGiftCardPolling()
            return
          }
          if (
            this.isAddAdviser === false &&
            !this.hasRedirected &&
            this.adviserDetail &&
            this.adviserDetail.userUseStatus != null &&
            this.adviserDetail.userUseStatus !== 4
          ) {
            this.isAddAdviser = true
            this.getGiftCardById()
            this.stopUseGiftCardPolling()
            return
          }
          if (this.adviserDetail.startTime && !this.countdownTime) {
            const startTime = new Date(this.adviserDetail.startTime).getTime()
            const counTime = 10 * 60 - Math.max(0, Math.floor((Date.now() - startTime) / 1000))
            const remaining = counTime < 0 ? 0 : counTime
            this.countdownTime = remaining
          }
        })
    },
    // 开始倒计时
    startCountdown() {
      if (this.countdownTimer) clearInterval(this.countdownTimer)
      this.countdownTimer = setInterval(() => {
        if (this.countdownTime > 0) {
          this.countdownTime--
        } else {
          clearInterval(this.countdownTimer)
        }
      }, 1000)
    },
    // 清除倒计时
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    }
  },
  beforeDestroy() {
    this.clearCountdown()
    this.stopUseGiftCardPolling()
  }
}
</script>
<style lang="less">
.content {
  img {
    width: 100%;
    height: auto;
  }
}
</style>
<style lang="less" scoped>
.display {
  display: none;
}

.mint-msgbox-message {
  color: #000000 !important;
  font-size: 0.32rem;
}
.mint-msgbox-cancel {
  color: #000000 !important;
  border-right: 1px solid #ddd !important;
}
.confirm-btn-class {
  color: #00b25a !important;
  background-color: #fff !important;
}
.gift-card-page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .background {
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
    }
  }
  .con {
    width: 100%;
    position: absolute;
    padding: 0.24rem;
    padding-bottom: 3.6rem;
  }
  .gift-detail {
    background: #f2f7f7;
    margin: 1rem -0.24rem 0;
    padding: 0.24rem;
    .detail-title {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.2rem 0 0.44rem;
      color: #00b25a;
      font-size: 16px;
      font-weight: bold;
      &::before,
      &::after {
        content: '';
        height: 6px;
        width: 54px;
        background-image: url('~@/pages/payment/images/title-icon.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      &::before {
        margin-right: 0.16rem;
      }
      &::after {
        margin-left: 0.16rem;
        transform: scaleX(-1);
      }
    }
  }
  .card {
    img {
      width: 100%;
      border-radius: 0.16rem;
    }
  }
  .intro {
    margin-top: 0.32rem;
    font-size: 0.28rem;
    color: #666666;
    line-height: 0.4rem;
    margin-bottom: 0.08rem;
    .tit {
      font-size: 0.36rem;
      font-weight: bold;
      color: #00b25a;
      margin-bottom: 0.16rem;
    }
  }

  .btn {
    width: 100%;
    border-radius: 0.12rem;
    border: 1px solid #00b25a;
    background-color: #fff;
    font-size: 0.32rem;
    padding: 0.24rem 0;
    color: #00b25a;
    margin-bottom: 0.24rem;
  }
  .bg {
    background-color: #00b25a;
    color: #fff;
  }
  .unbg {
    background-color: #eeeeee;
    color: #999999;
    border: none;
  }
  .gif-card-commit {
    color: #999;
    margin-bottom: 0.24rem;
    font-size: 0.24rem;
  }
  .gift-message-h {
    padding-top: 0.48rem;
    margin-top: 0.48rem;
    border-top: 1px #eee solid;
  }
  .gift-message-card {
    margin-bottom: 0.24rem;
  }
  .gift-message-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.16rem;
  }
  .gift-message-actions {
    display: flex;
    align-items: center;
  }
  .gift-message-title {
    font-size: 0.32rem;
    font-weight: bold;
    color: #000;
  }
  .gift-message-edit {
    font-size: 0.24rem;
    color: #999;
    margin-left: 0.24rem;
    &.save {
      font-weight: bold;
    }
  }
  .gift-message-count {
    font-size: 0.24rem;
    color: #999;
  }
  .gift-message-editor {
    margin-bottom: 0.08rem;
  }
  .gift-message-textarea {
    width: 100%;
    min-height: 0.44rem;
    border: none;
    background: transparent;
    resize: none;
    outline: none;
    overflow: hidden;
    padding: 0;
    font-size: 16px;
    line-height: 31px;
    color: #333333;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='30' viewBox='0 0 200 30' preserveAspectRatio='none'%3E%3Cline x1='0' y1='29' x2='200' y2='29' stroke='%23e6e6e6' stroke-width='1' stroke-dasharray='6 4'/%3E%3C/svg%3E");
    background-repeat: repeat-y;
    background-size: 100% 30px;
  }
  .gift-message-content {
    font-size: 16px;
    line-height: 31px;
    color: #333333;
    white-space: pre-wrap;
    word-break: break-all;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='30' viewBox='0 0 200 30' preserveAspectRatio='none'%3E%3Cline x1='0' y1='29' x2='200' y2='29' stroke='%23e6e6e6' stroke-width='1' stroke-dasharray='6 4'/%3E%3C/svg%3E");
    background-repeat: repeat-y;
    background-size: 100% 30px;
  }
  .gift-message-footer {
    display: flex;
    align-items: flex-end;
    margin-top: 0.24rem;
    color: #000;
    flex-direction: column;
    font-size: 16px;
    .gift-message-name {
      margin-bottom: 0.08rem;
    }
  }

  .btns {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 0.24rem;
    .btn {
      flex: 1;
      margin-bottom: 0;
    }
  }
  .tip {
    font-size: 0.24rem;
    color: #ff8000;
  }
  .fixed-bottom {
    .tips {
      background: linear-gradient(0deg, rgba(255, 170, 0, 0.1) 0%, rgba(255, 170, 0, 0.1) 100%), #fff;
      padding: 10px 0;
      text-align: center;
      margin: -16px -16px 16px;
    }
  }
  .flexdiv.average {
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 100%;
      margin-bottom: 0;
    }
  }
}
.container-bg {
  position: relative;
  min-height: 100vh;
  background-image: url('../../images/add_teacher_bg.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  .btn-common {
    margin: 0.8rem 0.96rem 0;
  }
  .title {
    position: relative;
    width: 218px;
    margin-top: 30px;
    left: 50%;
    margin-left: -109px;
  }
  .border-popup-white {
    margin: 12px;
  }
  .ccontent {
    padding: 22px 24px 24px;
    background: #fff;
    font-size: 16px;
    .text {
      margin-bottom: 12px;
      margin-left: 30px;
    }
    .text1 {
      position: relative;
      padding-left: 30px;
      margin-left: 0px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        background-image: url('../../images/subVIp/success.png');
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    .text2 {
      height: 43px;
      border-left: 1px solid rgb(0, 178, 90);
      padding-left: 21px;
      margin-left: 8px;
    }
    .text3 {
      position: relative;
      padding-left: 30px;
      margin-left: 0px;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        background-image: url('../../images/subVIp/no.png');
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    .adviserCode {
      margin-left: 30px;
      background: #f2f2f2;
      padding: 30px;
      border-radius: 10px;

      .img {
        width: 196px;
        height: 196px;
      }
      .long-tap-box {
        opacity: 0.5;
        font-size: 12px;
        margin-top: 12px;
        text-align: center;
      }
    }
  }
  .ctext {
    position: relative;
    padding-top: 3.2rem;
    text-align: center;
    color: #ffffff;
    .countdown-time {
      font-size: 36px;
      font-weight: bold;
      line-height: 1;
      margin-bottom: 0.24rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .time {
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 6px;
        width: 56px;
        height: 56px;
      }
    }
    .main-title {
      font-size: 0.4rem;
      font-weight: bold;
      margin-bottom: 0.32rem;
    }
    .second-title {
      font-size: 0.24rem;
      margin-bottom: 0.5rem;
      line-height: 1.5;
      opacity: 0.7;
    }
    .qr-box {
      margin: 1rem 0;
      img {
        width: 3.2rem;
      }
      .img-text {
        color: #00b25a;
        margin-bottom: 0.32rem;
      }
      .long-tap-box {
        color: #999;
      }
    }
    .note-box {
      margin-top: 1.2rem;
      border-radius: 0.32rem;
      border: 1px solid rgba(255, 255, 255, 0.3);
      background: rgba(255, 255, 255, 0.3);
      padding: 0.16rem;
      margin-bottom: 0.48rem;
      .note-main {
        background: #fff;
        color: #999;
        border-radius: 0.32rem;
        text-align: left;
        padding: 0.32rem;
        .note-title {
          color: #00b25a;
          font-size: 0.32rem;
          font-weight: bold;
        }

        .note-content {
          line-height: 1.5;
          white-space: break-spaces;
          margin-top: 0.24rem;
        }
      }
    }
  }
  .logo-img {
    position: absolute;
    bottom: 0.64rem;
    left: 0;
    right: 0;
    text-align: center;
    img {
      width: 2rem;
    }
  }
}
.poster-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  .poster-wrapper {
    position: relative;
    width: 80%;
    max-width: 6rem;
  }
  .poster-img {
    width: 100%;
    border-radius: 0.16rem;
  }
  .poster-tip {
    text-align: center;
    color: #fff;
    font-size: 0.24rem;
    margin-top: 0.24rem;
  }
  .poster-close {
    position: absolute;
    top: -0.4rem;
    right: -0.4rem;
    width: 0.56rem;
    height: 0.56rem;
    line-height: 0.56rem;
    text-align: center;
    color: #fff;
    font-size: 0.36rem;
    border: 1px solid #fff;
    border-radius: 50%;
  }
}

#gift-card-poster {
  width: 375px;
  background: #fff;
  padding: 25px 12px 0;
  height: auto;
  position: relative;
  top: -99999px;
  left: -9999px;
  .card-detail {
    position: relative;
    z-index: 1;

    .card-name {
      font-size: 20px;
      font-weight: 600;
      color: #fff;
      text-align: center;
      margin-bottom: 18px;
    }
    .card-img {
      img {
        width: 100%;
        border-radius: 8px;
      }
    }
    .gift-message-card {
      padding: 40px 24px;
      position: relative;
      .gift-message {
        line-height: 1.5;
      }
      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        background: url('../../images/goods/content_bg.png') no-repeat;
        background-size: 100% 100%;
      }
      &::before {
        top: 12px;
        left: 0;
      }
      &::after {
        bottom: 12px;
        right: 0;
        transform: rotate(180deg);
      }
      .gift-message-footer {
        font-size: 14px;
      }
    }
    .poster-share {
      display: flex;
      align-items: center;
      padding: 12px;
      margin: 0 -12px;
      background: #f5f5f5;
      .poster-logo {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        flex-shrink: 0;
      }
      .poster-text {
        flex: 1;
        margin-left: 10px;
        overflow: hidden;
        .poster-title {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .poster-subtitle {
          font-size: 12px;
          color: #999;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-top: 2px;
        }
      }
      .poster-qrcode {
        width: 56px;
        height: 56px;
        flex-shrink: 0;
        margin-left: 10px;
      }
    }
  }
}
</style>
